import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getVeyaTeamToken } from "../../lib/api";

export default function VeyaTeamAuthGuard({ children }) {
  const location = useLocation();
  const token = getVeyaTeamToken();

  if (!token) {
    return (
      <Navigate
        to="/veya-team/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}